import React from "react";
import { Building2 } from "lucide-react";
import UseContext from "hooks/useContext";
import { InfoRow } from "components/missionDetail/MissionDetailParts";

// "Perimeter" line of the mission sheet. The caller hides it for a company that
// never had a perimeter (hasPerimeters false or absent from an older api).
const MissionPerimeterRow = ({ perimeter, canChange, onChange }) => {
    const { language } = UseContext();

    const value = perimeter
        ? `${perimeter.name}${perimeter.archived ? ` ${language.getValue("perimeters.missionDetail.archived")}` : ""}`
        : language.getValue("perimeters.missionDetail.none");

    return (
        <InfoRow
            icon={Building2}
            label={language.getValue("perimeters.missionDetail.label")}
            value={value}
            action={
                canChange ? (
                    <button
                        type="button"
                        onClick={onChange}
                        className="rounded-md border border-gray-200 bg-white px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50 active:bg-gray-100"
                    >
                        {language.getValue("perimeters.missionDetail.edit")}
                    </button>
                ) : null
            }
        />
    );
};

export default MissionPerimeterRow;
